import { IHttpResponse, IPromise } from 'angular';

import { Helpers } from '../helpers/Helpers';
import { Module } from '../Module';

export interface IAuthenticateDatabaseParams {
  authentication: string;
  username: string;
  password?: string;
  reuse_forever?: boolean; // Use this if GlobalSetting.get_bool("remember_passwords_forever")
  reuse?: boolean;
  crypted: string;
  connection: string;
  path: string;
  authenticity_token?: string;
  oauthrequest?: boolean;
}

export class ConnectionAuthService {

  public static $inject = [
    '$http'
  ];

  constructor(
    private $http: ng.IHttpService
  ) { }

  public authenticate(path: string, data: IAuthenticateDatabaseParams): IPromise<IHttpResponse<{}>> {
    return this.$http({
      method: 'POST',
      url: path,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: Helpers.serialize(data)
    });
  }

}

Module.instance().service('ConnectionAuthService', ConnectionAuthService);
